export default __webpack_public_path__ + "static/media/reactbanner.c739993e.jpeg";